import {
  Typography,
  Stack,
  Chip,
  Grid,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  Button,
} from "@mui/material";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import {
  Purchase_Close__Summary_Detail_GetRow,
  Purchase_Close_Summary_Detail_GetRow,
  Purchase_Reopen,
  Purchase_RequestCloseApi,
  Purchase_Summary_Detail_GetRow,
} from "../../Server/ApiV2";
import { fAlertToast } from "../../Utility/Utilitys";
import "./purchase-summary.css";
import ClosePurchaseConfirm from "./Components/ClosePurchaseConfirm";
import { confirmAlert } from "react-confirm-alert";

const departmentTextStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 2, // show only 2 lines
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis", // show …
  whiteSpace: "normal", // allow wrapping
};

function Info({ label, value }) {
  return (
    <Stack
      spacing={0.5}
      sx={{
        flexDirection: "row",
        alignItems: "baseline",
        justifyContent: "space-between",
      }}
    >
      <Typography
        variant="caption"
        color="text.primaryCaption"
        sx={{ width: label ? "50%" : "0%" }}
        component="div"
      >
        {label}
      </Typography>
      <Typography
        variant="body1"
        sx={{ width: label ? "50%" : "100%" }}
        component="div"
        // style={departmentTextStyle}
      >
        {value}
      </Typography>
    </Stack>
  );
}

export function PurchaseSummaryModal({
  open,
  onClose,
  onLoad,
  header,
  isMobile,
  UserCd,
  importPurchaseRows,
  isFromPurchaseClose = false,
}) {
  const apiRef = useGridApiRef();
  const [summaryRows, setSummaryRows] = useState([]);
  const [closeConfirm, setCloseConfirm] = useState(false);

  const columns = [
    {
      field: "CategoryName",
      headerName: "Category",
      flex: 1,
      minWidth: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "Range",
      headerName: "Range",
      width: 70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "ReqQty",
      headerName: "ReqQty",
      type: "number",
      width: 70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Qty",
      headerName: "PurQty",
      type: "number",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "PurchasedQty",
      headerName: "Purchased Qty",
      type: "number",
      width: 110,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "BalanceQty",
      headerName: "BalQty",
      type: "number",
      width:70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Ratio",
      headerName: "Ratio",
      type: "number",
      width:70,
      align: "center",
      headerAlign: "center",
    },
  ];

const updatedHeader = useMemo(() => {
  if (!importPurchaseRows?.length || !header) return null;
  return importPurchaseRows?.find((obj) =>
    isFromPurchaseClose
      ? obj?.TripId === header?.TripId
      : obj?.TransId === header?.TransId
  );
}, [importPurchaseRows, header, isFromPurchaseClose]);

  const purchaseSummaryCloseGetRow = async () => {
    const res = await Purchase_Close__Summary_Detail_GetRow({
      TripID: header?.TripId,
    });
    if (res?.status === 200) {
      const uniqueIdResult = res?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: `purchase-summary-row-${i}`,
      }));
      setSummaryRows(uniqueIdResult || []);
    }
  };

  const purchaseSummaryGetRow = async () => {
    const res = await Purchase_Summary_Detail_GetRow({
      TransId: header?.TransId,
    });
    if (res?.status === 200) {
      const uniqueIdResult = res?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: `purchase-summary-row-${i}`,
      }));
      setSummaryRows(uniqueIdResult || []);
    }
  };

  const purchaseCloseRequest = async () => {
     confirmAlert({
       title: "Close",
       message: "Are you want to Close this request",
       buttons: [
         {
           className: "alertBtn",
           label: "Yes",
           onClick: async () => {
             const res = await Purchase_RequestCloseApi({
               TripId: header?.TripId,
               UserCd,
             });
             if (res?.status === 200) {
               fAlertToast("SUCCESS", "Request closed successfully");
               onLoad();
             }
           },
         },
         {
           className: "alertBtn",
           label: "No",
           onClick: () => "",
         },
       ],
     });
  };

 const reOpenPurchase = async () => {
    try {
      const res = await Purchase_Reopen({
        TransId: header?.TransId,
        UserCd,
      });
      if (res?.status === 200) {
        fAlertToast("SUCCESS", "Reopened successfull");
        onLoad();
      }
    } catch (error) {}
 }

  const handleExport = () => {
    apiRef.current.exportDataAsCsv(); // or exportDataAsExcel(), etc.
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

const ratio = useMemo(() => {
  if (!Array.isArray(summaryRows) || !summaryRows?.length) return 0;

  const totals = summaryRows?.reduce(
    (a, r) => {
      a.purchased += Number(r?.PurchasedQty) || 0; // include ALL purchased
      a.requested += Number(r?.ReqQty) || 0; // sum all requests
      return a;
    },
    { purchased: 0, requested: 0 }
  );

  return totals.requested > 0
    ? Math.min((totals.purchased / totals.requested) * 100, 100) // global cap at 100%
    : 0;
}, [summaryRows]);


const pct = Number.isFinite(ratio) ? ratio : 0;
const ratioLabel = `${pct.toFixed(2)}%`;
  

  useEffect(() => {
    if (open) {
      if (isFromPurchaseClose) {
        purchaseSummaryCloseGetRow();
      } else {
        purchaseSummaryGetRow();
      }
    }
  }, [open]);

  return (
    <>
      <Dialog
        fullScreen={isMobile}
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={() => {
          onClose();
          setSummaryRows([]);
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: "#0d73bb",
            padding: "6px 0px 6px 12px !important",
            color: "#fff",
          }}
        >
          {isFromPurchaseClose ? "Import Purchase Deactivate" : "Import Purchase"}
          <IconButton
            onClick={() => {
              onClose();
              setSummaryRows([]);
            }}
            sx={{ color: "#fff" }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{ height: "75vh", padding: { xs: "8px", md: "12px 20px" } }}
        >
          <Card variant="elevation" elevation={5}>
            <CardContent sx={{ padding: "10px !important" }}>
              {isFromPurchaseClose ? (
                <Grid container spacing={{ xs: 0.5, md: 1 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Info label="Trip Id" value={header?.TripId} />
                    <Info label="Trip Name" value={header?.Name} />
                    <Info label="Buyer" value={header?.BuyerName} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Info
                      label="No Of Excel Count"
                      value={header?.NoOfExcelCount}
                    />
                    <Info label="No Of Orders" value={header?.NoOfOrders} />
                    <Info label="No Of Purchase" value={header?.NoOfPurchase} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Info
                      label="Expected From"
                      value={moment(header?.Expt_From).format("DD/MM/YYYY")}
                    />
                    <Info
                      label="Expected To"
                      value={moment(header?.Expt_To).format("DD/MM/YYYY")}
                    />
                    <Info
                      label="Status"
                      value={
                        <Chip
                          size="small"
                          color={
                            String(updatedHeader?.status).toUpperCase() !==
                            "ENTER"
                              ? "success"
                              : "warning"
                          }
                          label={updatedHeader?.status}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={{ xs: 0.5, md: 1 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Info label="Order ID" value={header?.TransId} />
                    <Info
                      label="Order Date"
                      value={moment(header?.Date).format("DD/MM/YYYY")}
                    />
                    <Info
                      label="Order Location"
                      value={header?.TransLoc_Name}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Info label="Forecast Days" value={header?.ForecastDays} />
                    <Info
                      label="Expiry Date"
                      value={
                        header?.ExpiredDate
                          ? moment(header.ExpiredDate).isValid()
                            ? moment(header.ExpiredDate).format("DD/MM/YYYY")
                            : ""
                          : ""
                      }
                    />
                    <Info label="PurchaseRatio" value={header?.PurRatio} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Info
                      label="Purchase Status"
                      value={
                        <Chip
                          size="small"
                          color={
                            String(updatedHeader?.Pur_Status).toUpperCase() !==
                            "ENTER"
                              ? "success"
                              : "warning"
                          }
                          label={updatedHeader?.Pur_Status}
                        />
                      }
                    />
                    <Info
                      label="Close Status"
                      value={
                        <Chip
                          size="small"
                          color={
                            String(
                              updatedHeader?.Close_Status
                            ).toUpperCase() !== "ENTER"
                              ? "success"
                              : "warning"
                          }
                          label={updatedHeader?.Close_Status}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Info value={header?.GroupName} />
                  </Grid>
                </Grid>
              )}
            </CardContent>
          </Card>

          {!isMobile && <Divider sx={{ my: 1.5 }} />}
          <Box sx={{ height: { xs: "34vh", md: "40vh", lg: "42vh" } }}>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <div>
                {isFromPurchaseClose ? (
                  <Button
                    size="small"
                    variant="contained"
                    sx={{ mr: 1, my: 1 }}
                    onClick={purchaseCloseRequest}
                    disabled={updatedHeader?.status !== "ENTER"}
                  >
                    Close Trip
                  </Button>
                ) : (
                  <>
                    <Button
                      size="small"
                      variant="contained"
                      sx={{ mr: 1, my: 1 }}
                      onClick={() => setCloseConfirm(true)}
                      disabled={
                        String(updatedHeader?.Pur_Status).toUpperCase() !==
                          "ENTER" ||
                        String(updatedHeader?.Close_Status).toUpperCase() !==
                          "ENTER"
                      }
                    >
                      Close Purchase
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      sx={{ mr: 1, my: 1 }}
                      onClick={reOpenPurchase}
                      disabled={
                        !(
                          String(updatedHeader?.Pur_Status).toUpperCase() ===
                            "POST" &&
                          String(updatedHeader?.Close_Status).toUpperCase() ===
                            "ENTER"
                        )
                      }
                    >
                      Reopen
                    </Button>
                  </>
                )}
                <Button
                  size="small"
                  variant="contained"
                  sx={{ mr: 1, my: 1 }}
                  onClick={handleExport}
                >
                  Export
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ mr: 1, my: 1 }}
                  onClick={handlePrint}
                >
                  Print
                </Button>
              </div>
              <div className="donut">
                <div className="ring" style={{ "--p": pct }} />
                <span className="donut-text">{ratioLabel}</span>
              </div>
            </Stack>
            <DataGridPro
              apiRef={apiRef}
              rowHeight={30}
              headerHeight={40}
              rows={summaryRows ?? []}
              columns={columns}
              getRowId={(row) => row?.TransId}
              hideFooter
              sx={{
                border: 1,
                borderColor: "primary.light",
                height: "100%",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#0d73bb",
                  color: "white",
                },
                "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders":
                  {
                    backgroundColor: "#0d73bb",
                    color: "#fff",
                  },
                "& .MuiDataGrid-pinnedColumnHeaders": {
                  zIndex: 2,
                  textAlign: "left",
                },
                "& .MuiDataGrid-pinnedColumns--left": {
                  boxShadow: "4px 0 6px -4px rgba(37, 15, 15, 0.2)",
                },
              }}
              initialState={{
                pinnedColumns: !isMobile ? { left: ["CategoryName"] } : {},
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
      <ClosePurchaseConfirm
        onOpen={closeConfirm}
        onClose={() => setCloseConfirm(false)}
        ratio={ratioLabel} // e.g., 67.23
        header={updatedHeader} // must contain TransId
        UserCd={UserCd} // pass your user code
        onLoad={onLoad} // refresh list after success
      />
    </>
  );
}
